import { render, staticRenderFns } from "./PlayerTagDiscount.vue?vue&type=template&id=8d6c2034&"
import script from "./PlayerTagDiscount.vue?vue&type=script&lang=ts&"
export * from "./PlayerTagDiscount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports